import { IHeadContent } from '../types/headContent'
import { createIdentifier } from '@wix/thunderbolt-ioc'

export const HeadContentSymbol = createIdentifier<IHeadContent>(Symbol.for('HeadContentSymbol'))
export const HeadContentProviderSymbol = Symbol.for('HeadContentProviderSymbol')
export const HeadProviderSym = Symbol.for('HeadProviderSym')
export const HeadModelCalculatorSym = Symbol('HeadModelCalculator')
export const HeadersCalculatorSym = Symbol('HeadersCalculator')
export const TemplateRendererSym = Symbol('TemplateRenderer')
export const SiteModelSym = Symbol('SiteModel')
export const ModulesLoaderSym = Symbol('ModulesLoader')
export const SsrModelsBuilderSym = Symbol('SsrModelsBuilder')
export const FeaturesChunksExtractorSym = Symbol('FeaturesChunksExtractor')
export const ComponentsRegistryCalculatorSym = Symbol('ComponentsRegistryCalculatorSym')
